import { useEffect } from "react";

const DEFAULT_TITLE = "My Best Body Club™ | Data-Driven Nutrition & Body Composition";

export const usePageTitle = (title) => {
  useEffect(() => {
    document.title = title ? `${title} | My Best Body Club™` : DEFAULT_TITLE;
    return () => { document.title = DEFAULT_TITLE; };
  }, [title]);
};
